import PageBanner from "../components/PageBanner";
import Seo from "../components/Seo";
import { Reveal, SectionLabel } from "../components/Motion";
import { useApp } from "../AppContext";
import { C, IMAGES } from "../content";
import { Sunrise, Sun, Sunset, CheckCircle2, Clock } from "lucide-react";

const SLOT_ICONS = [Sunrise, Sun, Sunset];

export default function Darshan() {
  const { t, lang } = useApp();
  return (
    <div>
      <Seo title="Darshan & Daily Programme (Dincharya)" description="Daily programme at the Audumbar ashram: morning Datta puja and Samadhi puja, afternoon annadan, evening aarti and tirtha-prasad, plus visitor etiquette." />
      <PageBanner label={lang === "mr" ? "दिनचर्या" : "Daily Programme"} titleObj={C.dincharya} image={IMAGES.courtyardShrine} />

      <section className="py-16 lg:py-24 max-w-[1200px] mx-auto px-4 lg:px-8">
        <Reveal>
          <p className="text-earth-800 font-semibold mb-8 flex items-center gap-2"><Clock size={20} className="text-saffron-600" />{t(C.darshan, "hours")}</p>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-6">
          {C.dincharya.slots.map((s, i) => {
            const Icon = SLOT_ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div className="h-full rounded-2xl border border-earth-900/10 bg-white p-7" data-testid={`dincharya-${i}`}>
                  <div className="w-12 h-12 rounded-xl bg-saffron-500/10 text-saffron-600 flex items-center justify-center mb-5"><Icon size={24} /></div>
                  <h3 className="font-serif-head text-2xl text-earth-900 mb-4">{lang === "mr" ? s.when_mr : s.when_en}</h3>
                  <ul className="space-y-2">
                    {(lang === "mr" ? s.items_mr : s.items_en).map((it, j) => (
                      <li key={j} className="flex gap-2 text-earth-800"><CheckCircle2 size={18} className="shrink-0 text-deepred-700 mt-1" />{it}</li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal className="mt-16">
          <SectionLabel>{lang === "mr" ? "कृष्णा तीरावर वसलेला मठ" : "The Math on the Krishna Riverbank"}</SectionLabel>
          <div className="mt-4 rounded-3xl overflow-hidden border border-earth-900/10 shadow-[0_20px_50px_rgba(59,34,19,0.14)]" data-testid="krishna-river-photo">
            <img src={IMAGES.krishnaRiver} alt="Krishna river ghat and temple at Shri Datta Kshetra Audumbar" loading="lazy" className="w-full object-cover" />
            <div className="bg-earth-900 text-sand-100 text-center py-3 font-serif-head text-lg">
              {lang === "mr" ? "श्री दत्त क्षेत्र औदुंबर — कृष्णा नदी घाट" : "Shri Datta Kshetra Audumbar — Krishna river ghat"}
            </div>
          </div>
        </Reveal>

        <div className="mt-16">
          <Reveal><SectionLabel>{lang === "mr" ? "आचारसंहिता" : "Visitor Etiquette"}</SectionLabel></Reveal>
          <div className="mt-4 grid sm:grid-cols-2 gap-4">
            {C.dincharya.etiquette.map((e, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <div className="flex gap-3 rounded-xl bg-sand-100 border border-earth-900/10 px-5 py-4 text-earth-800 text-lg"><CheckCircle2 className="shrink-0 text-saffron-600 mt-1" size={20} />{e[lang] ?? e.en}</div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
